// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '939a07ea782f0678912ce15dcd75ec5e46fe57a4';
export const BUILD_NUMBER = '232';
export const BUILD_TIMESTAMP = '2026-09-10T04:16:47.506Z';
